<template>
  <div id="back-to-top-wrapper" :class="{hide: isHidden}">
    <a href="#top" class="btn back-to-top">
      <span class="btt-text">
        {{ pgettext('Back to top', 'Back') }}
        <br>
        {{ pgettext('Back to top', 'to top') }}
      </span>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'BackToTop',

    props: {
      showAfterOffset: {
        type: Number,
        default: 500
      },
    },

    data() {
      return {
        yOffset: window.pageYOffset
      }
    },

    computed: {
      isHidden() {
        return this.yOffset < this.showAfterOffset
      }
    },

    methods: {
      scrollListener() {
        this.yOffset = window.pageYOffset
      }
    },

    created() {
      window.addEventListener('scroll', this.scrollListener)
    },

    destroyed() {
      window.removeEventListener('scroll', this.scrollListener)
    }
  }
</script>



// WEBPACK FOOTER //
// js/BackToTop.vue